export default {

    panel: {

        orange: { 
            shadow: '#993F0F',
            main: '#BC4D12',
            short: '#171717',
            shortshadow: '#000000',
            chiffre: '#f4f4f4',
            rebord: '#ffffff',
            board: '#bc4d12',
            half: '#d38f51',
            button: '#bc4d12',
        }, 
        yellow: { 
            // shadow: '#c0ac2d',
            //main: '#D0BC28',
            shadow: '#D0BC28',
            main: '#F0D508',
            short: '#171717',
            shortshadow: '#000000',
            chiffre: '#171717',
            rebord: '#333333',
            board: '#F0D508',
            half: '#D0BC28',
            button: '#F0D508',
            // half: '#324442',
        }, 
        green: { 
            shadow: '#2C4E03',
            main: '#366004',
            short: '#ffffff',
            shortshadow: '#ebebeb',
            chiffre: '#f4f4f4',
            rebord: '#ffffff',
            board: '#487B0C',
            half: '#80A725',
            button: '#80A725'
        }, 
        blue: { 
            shadow: '#273c7f',
            main: '#3351B9',
            short: '#ffffff',
            shortshadow: '#C7CFEB',
            chiffre: '#f4f4f4',
            rebord: '#ffffff',
            board: '#3351B9',
            half: '#6F84CC',
            button: '#3351B9'
        }, 

        dark: { 
            shadow: '#1F1F1F',
            main: '#000000',
            short: '#000000',
            shortshadow: '#000000',
            chiffre: '#f4f4f4',
            rebord: '#000000',
            half: '#495253',
            board: '#000000',
            // half: '#8B9393',
            button: '#324442'
        }, 
        purple: { 
            shadow: '#621456',
            main: '#8A1B79',
            // #8A1B79
            short: '#f4f4f4',
            shortshadow: '#DBA6D3',
            chiffre: '#f4f4f4',
            rebord: '#ffffff',
            board: '#8A1B79',
            half: '#D579C7',
            button: '#8A1B79',
        }, 
    },

    dark: '#324442',
    field: '#95b633',
    twentytwo: '#79944c',
    stage: '#5d7253',
    blue: '#3351B9',
    green: '#497c0c',
    orange: '#BC4C12', // #aa2a0a
    //yellow: '#D0BC28',
    yellow: '#F0D508',
    purple: '#8A1B79',

    board_blue: '#3351B9',
    half_blue: '#6c9aa2',
    board_green: '#487B0C',
    half_green: '#80A725',
    board_orange: '#bc4d12',
    half_orange: '#d38f51',
    board_dark: '#324442',
    half_dark: '#8B9393',
    board_yellow: '#D0BC28',
    half_yellow: '#324442',

    board_purple: '#8A1B79',
    half_purple: '#D579C7',
        
}


